export const PenIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#a)' fill='currentColor'>
      <path
        d='M.04 19.234a.588.588 0 0 0 .562.746q.084 0 .16-.023l5.461-1.559L1.6 13.773z'
        fill='currentColor'
      />
      <path
        d='M.603 20a.6.6 0 0 1-.578-.77l1.57-5.492 4.672 4.672-5.5 1.567A.6.6 0 0 1 .603 20m1.008-6.191L.06 19.239a.565.565 0 0 0 .7.695l5.429-1.551zM19.466 3.016l-2.48-2.48A1.76 1.76 0 0 0 15.738.02c-.468 0-.91.183-1.242.511l-1.242 1.242 4.965 4.965 1.242-1.242c.332-.332.512-.773.512-1.242a1.73 1.73 0 0 0-.508-1.238'
        fill='currentColor'
      />
      <path
        d='M18.224 6.766 13.23 1.773 14.485.52A1.76 1.76 0 0 1 15.74 0c.477 0 .922.184 1.254.52L19.473 3c.337.336.52.781.52 1.254 0 .477-.183.922-.52 1.254zm-4.938-4.993 4.938 4.938 1.226-1.227a1.72 1.72 0 0 0 .508-1.226c0-.465-.18-.899-.508-1.227L16.97.547a1.73 1.73 0 0 0-1.23-.508c-.466 0-.9.18-1.227.508zM2.258 12.774 12.43 2.602l4.966 4.966L7.224 17.74z'
        fill='currentColor'
      />
      <path
        d='m7.224 17.77-4.996-4.996 10.203-10.2 4.992 4.992zm-4.938-4.996 4.938 4.937L17.368 7.566 12.431 2.63z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
)
